import React, {useEffect, useState} from "react";
import {Form, Collapse, Card, DatePicker, Col, Button, Row, Select} from "antd";
import jsonfile from "./localexpenses.json";
import {useHistory} from "react-router-dom";
import {CisUI} from "../../../../util/CISUI";
import "react-smart-data-table/dist/react-smart-data-table.css";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";
import "jspdf-autotable";
import IntlMessages from "../../../../util/IntlMessages";

const {MonthPicker} = DatePicker;
const {Option} = Select;
const Panel = Collapse.Panel;

const RegionSummaryReport = () => {
    const formRef = React.createRef();
    const [state, setState] = useState({
        reqURL: Config.apiserver + jsonfile.urls.summary,
        filtervalue: "",
        reportTitle: "",
        reportData: [],
        totalContribution: 0,
        month: "",
        region: "",
        district: "",
        contribution: [],
        expensesMission: [],
        expensesOffice: [],
        totalExpenses: 0,
        totalExpensesOffice: 0,
        totalExpensesMission: 0,
        netTitheAfterExpense: 0,
        rdf: 0,
        aidf: 0,
        retainRDF: 0,
        NetTitheToNation: 0,
        missionOffering: 0,
        MinistryIncome: 0,
        Mckeowns: 0,
        InternalMissions: 0,
        NationalPrayer: 0,
        PENSOS: 0,
        netCashToNation: 0,
    });
    const [regions, setRegions] = useState([]);
    const comArea = CisUI().getUserInfo('comarea');

    const history = useHistory();

    const [form] = Form.useForm();

    useEffect(() => {
        axios.get(Config.apiserver + 'regions')
            .then(res => {
                if (res?.data?.status === 1) {
                    setRegions(res?.data?.data)
                }
            })
            .catch(err => console.log(err));
    }, [])

    const handleMonthChange = (date) => {
        if (date) {
            const start = date.startOf("month");
            const end = date.endOf("month");
            form.setFieldsValue({date: [start, end]});
        }
    };

    const onFinish = (values) => {
        let data = {
            region_id: values.region_id,
        };

        if (values.date) {
            data.form_date = values.date[0].format("YYYY-MM-DD");
            data.to_date = values.date[1].format("YYYY-MM-DD");
        }

        if (values.month) {
            data.month = values.month.format("YYYY-MM");
        }

        const qs = Object.keys(data)
            .map((key) => `${key}=${data[key]}`)
            .join("&");
        const qsup = qs.replaceAll("undefined", "");

        history.push("?" + qsup);
        const newURL = Config.apiserver + jsonfile.urls.summary + "?" + qsup;

        let reportTitle = "";
        if (values.date) {
            const WKR = CisUI().ParseDateFormat(values.date);
            reportTitle = "Between " + CisUI().DateFormat(WKR[0]) + " and " + CisUI().DateFormat(WKR[1]);
        } else if (values.month) {
            reportTitle = "Month of " + CisUI().getMonthNameTimeStamp(values.month);
        }

        document.getElementById("loader").style.display = "block";
        axios
            .get(newURL)
            .then((res) => {
                document.getElementById("loader").style.display = "none";
                if (res.data.status === 1) {
                    const data = res.data.data;
                    setState({
                        reqURL: newURL,
                        contribution: data.contribution,
                        totalContribution: data.totalContribution,
                        district: data.district,
                        region: data.region,
                        reportTitle: reportTitle,
                        month: values.month ? CisUI().getMonthTitle(values.month.format("YYYY-MM-DD")) : "",
                        expensesOffice: data.expensesOffice,
                        expensesMission: data.expensesMission,
                        totalExpenses: data.totalExpenses,
                        totalExpensesOffice: data.totalExpensesOffice,
                        totalExpensesMission: data.totalExpensesMission,
                        netTitheAfterExpense: data.netTitheAfterExpense,
                        rdf: data.rdf,
                        aidf: data.aidf,
                        retainRDF: data.retainRDF,
                        NetTitheToNation: data.NetTitheToNation,
                        missionOffering: data.missionOffering,
                        MinistryIncome: data.MinistryIncome,
                        Mckeowns: data.Mckeowns,
                        InternalMissions: data.InternalMissions,
                        NationalPrayer: data.NationalPrayer,
                        PENSOS: data.PENSOS,
                        netCashToNation: data.netCashToNation,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                document.getElementById("loader").style.display = "none";
            });
    };

    let searchView = "";
    if (jsonfile.has_search) {
        searchView = (
            <Card className="advance-search-card no-print">
                <Collapse accordion expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel header="Advance Search" key="1">
                        <Form
                            key={5}
                            form={form}
                            ref={formRef}
                            {...CisUI().formItemLayout}
                            name="advanced_search"
                            className="ant-advanced-search-form"
                            onFinish={onFinish}
                        >
                            <Row gutter={16}>

                                {
                                    comArea <= 3 &&
                                    <Col span={6}>
                                      <Form.Item
                                          label="Area"
                                          name="region_id"
                                          rules={[
                                              {
                                                  required: false
                                              }
                                          ]}
                                      >
                                          <Select
                                              showSearch
                                              allowClear={true}
                                              placeholder="Select an option"
                                              optionFilterProp="children"
                                              filterOption={(input, option) => option.props.children?.toString().toLowerCase().indexOf(input?.toLowerCase()) >= 0 || false}
                                          >
                                              {
                                                  regions?.map((items, index) =>
                                                      <Option key={++index} value={items.id}>{items.name}</Option>
                                                  )
                                              }
                                          </Select>
                                      </Form.Item>
                                    </Col>
                                }
                                <Col span={6}>
                                    <Form.Item label="Month" name="month">
                                        <MonthPicker
                                            placeholder="Select month"
                                            format="MM/YYYY"
                                            style={{width: "100%"}}
                                            onChange={handleMonthChange}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item label="Date Range" name="date">
                                        <DatePicker.RangePicker style={{width: "100%"}}/>
                                    </Form.Item>
                                </Col>
                                <Col lg={6} md={6} sm={12} xs={24} style={{textAlign: "left", marginTop: "8px"}}>
                                    <Button type="primary" className="searchbutton" htmlType="submit">
                                        <i className="fas fa-search"/> <IntlMessages id={"Search"}/>
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Panel>
                </Collapse>
            </Card>
        );
    }

    const print = () => {
        // window.print();
        window.open(
            Config.baseurl +
            "summaryreport.html?url=" +
            window.btoa(state.reqURL) +
            "&filename=region_summary_report&data=regionsummeryData&subtitle=" +
            state.reportTitle +
            "&rptype=regionsummaryreport",
            "_blank",
        );
    };

    const listAction = () => (
        <div className="no-print">
            <a id="rploader" style={{width: "40px", height: "40px", display: "none"}}>
                <img src="/assets/images/loader.svg" style={{width: "40px", height: "40px"}} alt="loader"/> Please wait
                ...
            </a>

            <button onClick={print} className="btn btn-export-print btn-circle-md" title="Print">
                <i className="fas fa-print"/>
            </button>
        </div>
    );

    const getExtra = <>{listAction()}</>;

    return (
        <>
            {searchView}
            <Card extra={getExtra}>
                {CisUI().showLoading}
                <div id="region_summary">
                    <div className="row">
                        <div className="text-center col-md-12">
                            <h3>Area's Summary Report</h3>
                            <h2>{state.reportTitle}</h2>
                        </div>
                        <div className="col-md-6">
                            <table>
                                <tr>
                                    <th style={{textAlign: "right"}}>Area :</th>
                                    <td>{state.region}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th>Title</th>
                            <th style={{textAlign: "right"}}>Amount</th>
                            <th style={{textAlign: "right"}}>Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th>TOTAL CONTRIBUTION RECEIVED (Gross Tithe & Offering)</th>
                            <th style={{textAlign: "right"}}></th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.totalContribution)}</th>
                        </tr>

                        <tr>
                            <th>AREA OFFICE EXPENSES</th>
                            <th style={{textAlign: "right"}}></th>
                            <th style={{textAlign: "right"}}></th>
                        </tr>
                        {state.expensesOffice.map((items, index) => (
                            <tr>
                                <td>{items.title}</td>
                                <td style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(items.amount)}</td>
                                <td style={{textAlign: "right"}}></td>
                            </tr>
                        ))}

                        <tr>
                            <th>Total Expenses</th>
                            <th style={{textAlign: "right"}}></th>
                            <th style={{textAlign: "right"}}>({CisUI().getCurrencyFormated1(state.totalExpenses)})</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                Net Tithe After Area Expenses
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.netTitheAfterExpense)}</th>
                        </tr>
                        <tr>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                Less: Area Development Fund (ADF : 10%)
                            </th>
                            <th style={{textAlign: "right"}}>({CisUI().getCurrencyFormated1(state.rdf)})</th>
                        </tr>
                        {/*<tr>*/}
                        {/*    <th colSpan={2} style={{textAlign : 'right'}}></th>*/}
                        {/*    <td style={{textAlign : 'right'}}></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <th colSpan={2} style={{textAlign : 'right'}}>Distribution of 10% RDF</th>*/}
                        {/*    <td style={{textAlign : 'right'}}></td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td colSpan={2} style={{textAlign : 'right'}}>Retained 70% of RDF</td>*/}
                        {/*    <td style={{textAlign : 'left'}}>{CisUI().getCurrencyFormated1(state.retainRDF)}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <td colSpan={2} style={{textAlign : 'right'}}>Remit 30% of RDF As AIDF</td>*/}
                        {/*    <td style={{textAlign : 'left'}}>{CisUI().getCurrencyFormated1(state.aidf)}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*    <th colSpan={2} style={{textAlign : 'right'}}></th>*/}
                        {/*    <td style={{textAlign : 'right'}}></td>*/}
                        {/*</tr>*/}
                        <tr>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                Net Tithe to Nation
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.NetTitheToNation)}</th>
                        </tr>
                        <tr style={{display: "none"}}>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                Add : Missions Offering
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.missionOffering)}</th>
                        </tr>
                        <tr style={{display: "none"}}>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                <a href="#">Add : Ministry Income</a>
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.MinistryIncome)}</th>
                        </tr>
                        <tr style={{display: "none"}}>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                Add : Mckeowns
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.Mckeowns)}</th>
                        </tr>
                        <tr style={{display: "none"}}>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                Add : Internal Missions
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.InternalMissions)}</th>
                        </tr>
                        <tr style={{display: "none"}}>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                Add : National Prayer
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.NationalPrayer)}</th>
                        </tr>
                        <tr style={{display: "none"}}>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                Add : PENSOS
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.PENSOS)}</th>
                        </tr>
                        {/*<tr>*/}
                        {/*    <th colSpan={2} style={{textAlign : 'right'}}>Add : Other Funds(Mckeowns, Internal Missions, National Prayer, & PENSOS)</th>*/}
                        {/*    <th style={{textAlign : 'right'}}>{CisUI().getCurrencyFormated1(0)}</th>*/}
                        {/*</tr>*/}
                        <tr>
                            <th colSpan={2} style={{textAlign: "right"}}>
                                AMOUNT SENT TO NATION{" "}
                            </th>
                            <th style={{textAlign: "right"}}>{CisUI().getCurrencyFormated1(state.netCashToNation)}</th>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div id="elementH"></div>
            </Card>
        </>
    );
};

export default RegionSummaryReport;
